angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/companyRequest", {
        templateUrl: 'assets/companyRequest/index.html',
        controller: 'CompanyRequestController',
        title: 'companyRequest.TITLE',
        sidebar: 'companyRequest'
    })
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/routes/company_request_route.js
// module id = 810
// module chunks = 3